

import axios from 'axios';
import moment from 'moment';
import { URL } from '../tools/ApiRoutes';

// URL Authentication Endpoint

/**
 * Obtener clientes
 * @param {string} login - Usuario (opcional, se incluirá automáticamente por el interceptor)
 * @param {string} refreshToken - Token de refresco (opcional, se incluirá automáticamente por el interceptor)
 * @return {Promise} promise
 */
const getClients = () => {
    const headers = {
        'Content-Type': 'application/json',
    };

    // El interceptor agregará automáticamente login y refreshToken
    return axios.get(`${URL}/clientes`, {}, { headers })
        .then(({ data }) => {
            return data;
        });
};

/**
 * Obtener proyectos de clientes
 * @param {number} type - Tipo de consulta
 * @param {object} additionalData - Datos adicionales para la petición
 * @return {Promise} promise
 */
const getClientsProjects = (client) => {
    const headers = {
        'Content-Type': 'application/json',
    };

    return axios.get(`${URL}/clientes/proyectosPorCliente?Cliente=${client}`, {}, { headers })
        .then(({ data }) => {
            return data;
        });
};

export const ClientService = {
    getClients,
    getClientsProjects,
};